import styled from 'styled-components';
import tokens from 'assets/styles/tokens';

const Link = styled.span`
  font-weight: bold;
  cursor: pointer;
  color: ${tokens.colors.pink};
  text-decoration: none;
`;
export default Link;
